(function () {
  function initThumbSliders() {
    // Solo mobile
    if (!window.matchMedia("(max-width: 749px)").matches) return;

    document.querySelectorAll("[data-roussa-thumb]").forEach((wrap) => {
      const track = wrap.querySelector("[data-roussa-track]");
      const dotsWrap = wrap.closest(".card-wrapper")?.querySelector("[data-roussa-dots]");
      const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll(".roussa-thumb__dot")) : [];

      if (!track) return;

      let index = 0;
      const maxIndex = track.children.length - 1;

      const setIndex = (i) => {
        index = Math.max(0, Math.min(maxIndex, i));
        track.style.transform = `translateX(${-index * 100}%)`;
        if (dots.length) {
          dots.forEach((d, di) => d.classList.toggle("is-active", di === index));
        }
      };

      // Dots click
      if (dots.length) {
        dots.forEach((btn, i) => {
          btn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            setIndex(i);
          });
        });
      }

      // Swipe
      let startX = 0;
      let moved = false;

      track.addEventListener("touchstart", (e) => {
        startX = e.touches[0].clientX;
        moved = false;
      }, { passive: true });

      track.addEventListener("touchmove", (e) => {
        const dx = e.touches[0].clientX - startX;
        if (Math.abs(dx) > 10) moved = true;
      }, { passive: true });

      track.addEventListener("touchend", (e) => {
        const endX = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : startX;
        const dx = endX - startX;

        if (Math.abs(dx) > 35) {
          if (dx < 0) setIndex(index + 1);
          else setIndex(index - 1);
        }
      });

      // (Opcional) tap sin swipe → abre producto
      wrap.addEventListener("click", (e) => {
        if (moved) return; // si estaba swippeando no navegues
        const card = wrap.closest(".card-wrapper");
        const link = card?.querySelector('a[id^="CardLink-"]');
        if (link && link.href) window.location.href = link.href;
      });

      setIndex(0);
    });
  }

  document.addEventListener("DOMContentLoaded", initThumbSliders);
  window.addEventListener("resize", () => {
    // re-init simple
    initThumbSliders();
  });
})();
